import { render } from "./AppPostDetail.vue?vue&type=template&id=d32d00c6&scoped=true"
import script from "./AppPostDetail.vue?vue&type=script&lang=js"
export * from "./AppPostDetail.vue?vue&type=script&lang=js"

import "./AppPostDetail.vue?vue&type=style&index=0&id=d32d00c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b7c0161fc3875e000d6ad7ba26fe3ce3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d32d00c6"]])

export default __exports__